import gql from 'graphql-tag';

export const CreateAccidentIssue = gql`
  mutation CreateAccidentIssueBulk($input: CreateAccidentIssueBulkInput!) {
    createAccidentIssueBulk(input: $input) {
      output {
        error
        output {
          issue {
            id
            tripId
            createdAt
            createdBy
            updatedAt
            updatedBy
            deletedAt
            deletedBy
            traceId
            accidentDatetime
            dispatcherId
            samsaraCameraWorking
            stationText
            vehicleId
            driverId
            safetyId
            safetyNotified
            specificLocation
            wasThirdPartyInvolved
            thirdPartyInformation
            damageToOtherVehicles
            anyoneInjured
            medicalNeeded
            typeOfMedicalAttention
            infoOfInjuredParties
            wasCrewInvolved
            infoOfCrewMembers
            didDriverCallHelp
            canVehicleBeDriven
            wasDriverAtFault
            wasCeoCalled
            dispatcherContactedManager
            driverContactedManager
            additionalDriverScheduled
            description
            outboundFlightNumber
            outboundDatetime
            outboundFlightName
          }
          document {
            document {
              id
              createdAt
              createdBy
              updatedAt
              updatedBy
              issueId
              filename
              fileLocation
              contentType
              fileSize
              md5
              deletedAt
              deletedBy
              traceId
            }
            presignedUrl
          }
        }
      }
    }
  }
`;
